module.exports = __webpack_public_path__ + "static/media/grin-tongue-wink.a52bedac.svg";